<header
	[ngClass]="{ 'bg-transparent': isNegativeHeader }"
	class="header sticky top-0 z-20 md:relative"
	data-test-id="header"
>
	<vp-header-desktop
		[cta]="resolvedCta()"
		[hideMenu]="hideMenu()"
		[isNegativeHeader]="isNegativeHeader"
		[language]="language()"
		[menuItems]="menuItems()"
		[metaMenu]="metaMenu()"
		[title]="transformedTitle()"
		(languageSwitch)="onLanguageSwitch($event)"
		class="hidden md:block"
	/>
	<vp-header-mobile
		[cta]="resolvedCta()"
		[hideMenu]="hideMenu()"
		[isNegativeHeader]="isNegativeHeader"
		[menuItems]="menuItems()"
		[metaMenu]="metaMenu()"
		[title]="transformedTitle()"
		(languageSwitch)="onLanguageSwitch($event)"
		class="md:hidden"
	/>
</header>
